import { AlertTriangle, CheckCircle2 } from "lucide-react";

const fmt = (n) => (Number.isFinite(Number(n)) ? Number(n).toFixed(2).replace(/\.?0+$/, "") : "—");
const TOL = 0.05; // inches — DigiCut prints two decimals

// Shown on the upload review beside the traced L × W: what DigiCut printed for the template, and a flag when the two disagree.
// `piece` is the lead piece of a file (digicut_size / traced_size / size_flag come from the tracer); L / W are the values about to be saved.
export const DigicutCheck = ({ piece, L, W, testId }) => {
  if (!piece?.traced) return null;
  const sw = piece.software || "DigiCut";  // DigiCut or CORE (Eastman) — whichever program the screenshot came from
  const dc = piece.digicut_size;
  const flags = [];
  const typed = piece.size_unknown && Number(L) > 0 && Number(W) > 0;  // owner typed / picked the size the capture lacked: the long "boxes were empty" advice is done
  if (piece.size_flag && !typed) flags.push(piece.size_flag);
  if (dc && (Math.abs(Number(L) - dc[0]) > TOL || Math.abs(Number(W) - dc[1]) > TOL) && !(Math.abs(Number(L) - dc[1]) <= TOL && Math.abs(Number(W) - dc[0]) <= TOL)) {
    flags.push(`saving ${fmt(L)} × ${fmt(W)}" but ${sw} lists ${fmt(dc[0])} × ${fmt(dc[1])}"`);
  }
  const ok = dc && !flags.length;
  return (
    <div className="mt-0.5 flex flex-col items-end gap-0.5 whitespace-normal text-[10px]" data-testid={testId} data-ok={ok ? "1" : "0"}>
      {dc ? (
        <span className={`inline-flex items-center gap-1 font-mono ${ok ? "text-[#3ecf8e]" : "text-[#f5a524]"}`} title={piece.traced_size ? `${sw === "CORE" ? "Traced" : "Ruler read"} ${fmt(piece.traced_size[0])} × ${fmt(piece.traced_size[1])}" before sizing to ${sw}` : undefined}>
          {ok ? <CheckCircle2 className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />} {sw} {fmt(dc[0])} × {fmt(dc[1])}"
        </span>
      ) : (
        <span className={`inline-flex items-center gap-1 ${typed ? "text-[#9aa0a8]" : "text-[#f5a524]"}`} data-typed={typed ? "1" : "0"}>{typed ? <CheckCircle2 className="h-3 w-3 text-[#3ecf8e]" /> : <AlertTriangle className="h-3 w-3" />} {sw} L × W not read{typed ? " — using your size" : ""}</span>
      )}
      {flags.map((f, i) => <span key={i} className="max-w-[260px] text-right leading-tight text-[#f5a524]" data-testid={`${testId}-flag-${i}`}>{f}</span>)}
    </div>
  );
};

// Count of files on the review that don't match DigiCut — for the header summary
export const digicutMismatches = (groups) => groups.filter((g) => g.lead?.traced && g.lead.include && (g.lead.size_flag || !g.lead.digicut_size || Math.abs(Number(g.L) - g.lead.digicut_size[0]) > TOL || Math.abs(Number(g.W) - g.lead.digicut_size[1]) > TOL)).length;
